import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const statusBadge = (s) => {
  const map = { pending:'badge-yellow', approved:'badge-green', rejected:'badge-red', cancelled:'badge-gray' };
  return <span className={`badge ${map[s]||'badge-gray'}`}>{s}</span>;
};

export default function MyLeave() {
  const [leaves, setLeaves]     = useState([]);
  const [balance, setBalance]   = useState([]);
  const [types, setTypes]       = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ leave_type_id:'', from_date:'', to_date:'', half_day:'none', reason:'' });
  const [loading, setLoading]   = useState(false);
  const set = k => e => setForm(f => ({...f, [k]: e.target.value}));

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    const [l, b, t] = await Promise.all([
      api.get('/leave/my'),
      api.get('/leave/balance'),
      api.get('/leave/types'),
    ]);
    setLeaves(l.data);
    setBalance(b.data);
    setTypes(t.data);
  };

  const handleApply = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await api.post('/leave/apply', form);
      toast.success(`Leave applied for ${res.data.total_days} day(s)`);
      setShowForm(false);
      setForm({ leave_type_id:'', from_date:'', to_date:'', half_day:'none', reason:'' });
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to apply');
    } finally { setLoading(false); }
  };

  const handleCancel = async (id) => {
    if (!window.confirm('Cancel this leave application?')) return;
    try {
      await api.put(`/leave/${id}/cancel`);
      toast.success('Leave application cancelled');
      fetchData();
    } catch (err) {
      toast.error(err.response?.data?.error || 'Cannot cancel');
    }
  };

  return (
    <div>
      <div className="flex-between mb-16">
        <h1 className="page-title" style={{marginBottom:0}}>My Leaves</h1>
        <button className="btn btn-primary" onClick={() => setShowForm(!showForm)}>
          {showForm ? 'Cancel' : '+ Apply Leave'}
        </button>
      </div>

      {/* Balance cards */}
      <div className="stat-grid">
        {balance.map(b => (
          <div className="stat-card" key={b.id}>
            <div className="stat-num">{(b.total_days - b.used_days - b.pending_days).toFixed(1)}</div>
            <div className="stat-label">{b.leave_type_name}</div>
            <div className="text-sm text-muted" style={{marginTop:4}}>of {b.total_days} days</div>
          </div>
        ))}
      </div>

      {/* Apply form */}
      {showForm && (
        <div className="card mt-16">
          <div className="card-title">Apply for Leave</div>
          <form onSubmit={handleApply}>
            <div className="form-group">
              <label className="form-label">Leave Type</label>
              <select className="form-control" required value={form.leave_type_id} onChange={set('leave_type_id')}>
                <option value="">Select leave type</option>
                {types.map(t => <option key={t.id} value={t.id}>{t.name}</option>)}
              </select>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">From Date</label>
                <input className="form-control" type="date" required value={form.from_date} onChange={set('from_date')}/>
              </div>
              <div className="form-group">
                <label className="form-label">To Date</label>
                <input className="form-control" type="date" required value={form.to_date} onChange={set('to_date')}/>
              </div>
            </div>
            <div className="form-group">
              <label className="form-label">Half Day</label>
              <select className="form-control" value={form.half_day} onChange={set('half_day')}>
                <option value="none">Full Day(s)</option>
                <option value="morning">Half Day — Morning</option>
                <option value="afternoon">Half Day — Afternoon</option>
              </select>
            </div>
            <div className="form-group">
              <label className="form-label">Reason</label>
              <textarea className="form-control" rows="3" value={form.reason} onChange={set('reason')} placeholder="Reason for leave (optional)"/>
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              {loading ? 'Submitting...' : 'Submit Application'}
            </button>
          </form>
        </div>
      )}

      {/* Leave history */}
      <div className="card mt-16">
        <div className="card-title">Leave History</div>
        <div className="table-wrap">
          <table>
            <thead><tr><th>Type</th><th>From</th><th>To</th><th>Days</th><th>Status</th><th>Approved By</th><th>Action</th></tr></thead>
            <tbody>
              {leaves.length === 0 && <tr><td colSpan="7" className="text-center text-muted" style={{padding:24}}>No leave applications found</td></tr>}
              {leaves.map(l => (
                <tr key={l.id}>
                  <td>{l.leave_type_name}</td>
                  <td>{new Date(l.from_date).toLocaleDateString('en-IN',{day:'2-digit',month:'short'})}</td>
                  <td>{new Date(l.to_date).toLocaleDateString('en-IN',{day:'2-digit',month:'short',year:'numeric'})}</td>
                  <td>{l.total_days}{l.half_day!=='none'?` (${l.half_day})`:''}</td>
                  <td>{statusBadge(l.status)}</td>
                  <td>{l.approved_by_name || '—'}</td>
                  <td>
                    {l.status === 'pending' && (
                      <button className="btn btn-outline btn-sm" onClick={() => handleCancel(l.id)}>Cancel</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
